module.exports = __webpack_public_path__ + "img/ultra.ae3116d9.png";